export default __webpack_public_path__ + "static/media/Mario.af5434fc.png";